<!-- eslint-disable @angular-eslint/template/alt-text -->
<div cdkDragHandle class="photo" [style.height.px]="proportionalHeight">
  <span *ngIf="!useAsContainerOnly" class="span-loading">Loading...</span>
  <ng-container *ngIf="!useAsContainerOnly">
    <ng-container *ngIf="imageFirst && !imageSecond">
      <img class="full" [src]="imageFirst" (error)="imgErrorHandler($event)" />
    </ng-container>

    <ng-container *ngIf="imageFirst && imageSecond">
      <img class="image-preview left" [src]="imageFirst" (error)="imgErrorHandler($event)" />
      <img class="image-preview right" [src]="imageSecond" (error)="imgErrorHandler($event)" />
    </ng-container>

    <div class="flex photo-content jcsb">
      <rx-row class="photo-content-actions flex-nosize" [ngClass]="showCheckbox ? 'jcsb' : 'jcfe'">
        <mat-checkbox *ngIf="showCheckbox" [checked]="checked" (click)="checkedChanged($event)"></mat-checkbox>

        <div [rxRoleGuard]="rejectedRoles" *ngIf="showMenuHandle" class="action-controls flex flex-row flex-nosize">
          <rx-icon
            *ngIf="showMenuHandle"
            name="icon-shadow-menu"
            class="rel z1 cp"
            [class.disabled]="disableMenu"
            (click)="onMenuClicked($event)"
            [matMenuTriggerFor]="actionMenu"
            [matMenuTriggerData]="actionMenuContext"
          ></rx-icon>
        </div>
      </rx-row>

      <div class="description">
        {{ description }}
      </div>
    </div>
  </ng-container>

  <ng-content></ng-content>
</div>
